import Vue from "vue";
import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    // listAllActualProducts: [],
    details: {},
    model: {
      id: "",
      name: "",
      categoryId: null,
      attributesGroupCommand: [
        {
          name: "",
          priority: null,
          productAttributeCommands: []
        }
      ]
    },
    loading: false
  },
  getters: {
    model: state => state.model,
    list: state => state.list,
    // listAllActualProducts: (state) => state.list,
    details: state => state.details,
    loading: state => state.loading
  },
  actions: {
    fetch({ commit, dispatch }, id) {
      return ajax.get("ProductManagement/api/GenericProductsQuery/").then(r => {
        commit("setList", r.data.data);
      });
    },
    fetchNoSkip({ commit, dispatch }) {
      return ajax
        .get("ProductManagement/api/GenericProductsQuery?Take=5000&Skip=0")
        .then(r => {
          commit("setList", r.data.data);
        });
    },
    fetchSingleWithoutInput({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/GenericProductsQuery?Take=5000&Skip=0")
          .then(r => {
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchSingle({ commit, dispatch }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/GenericProductsQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax
        .post("ProductManagement/api/GenericProducts", model)
        .then(r => {
          dispatch("fetch");
        });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "ProductManagement/api/GenericProducts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(r => {
          dispatch("fetch");
        });
    },
    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/GenericProductsQuery/name?name=" + name)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchFullSearch({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/GenericProductsQuery?" + model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchSearchAllActualProducts({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "ProductManagement/api/ActualProductsQuery/filter-by-name?" + name
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    attributeIsnotDuplicatedInProductAttributes(
      { state },
      { attributeId, groupIndex }
    ) {
      return new Promise((resolve, reject) => {
        var isDuplicated = false;
        var group = state.details.attributeGroups[groupIndex];
        group.productAttributes.forEach(pa => {
          if (pa.attributeId == attributeId) isDuplicated = true;
        });
        if (isDuplicated) reject();
        else resolve();
      });
    },
    removeGroup({ commit }, index) {
      commit("removeGroup", index);
    },
    removeProductAttribute({ commit }, { gIndex, paIndex }) {
      commit("removeProductAttribute", { gIndex, paIndex });
    },
    submitData({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        ajax
          .put("ProductManagement/api/GenericProducts", state.details)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    ////
    listGenericProductPerContract({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/GenericProductDeductionAndIncreasesQuery/generic-products-Info-of-contract/" +
              model.deductionAndIncreaseId +
              "?take=100&skip=" +
              model.startData
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    assignItemInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("ProductManagement/api/GenericProducts/item", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    unassignItemInfo(
      { commit, dispatch },
      { parentGenericProductId, genericProductId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "ProductManagement/api/GenericProducts/item",
            {
              data: {
                parentGenericProductId: parentGenericProductId,
                genericProductId: genericProductId
              }
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  },

  mutations: {
    setList(state, data) {
      state.list = data;
    },
    // setListAllActualProducts(state, data) {
    //   state.list = data;
    // },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },

    setDetailsFields(state, { field, value }) {
      state.details[field] = value;
    },
    addAttributeGroupToDetails(state, data) {
      if (!state.details.attributeGroups) state.details.attributeGroups = [];
      state.details.attributeGroups.unshift(data);
    },
    setAttributeGroupFieldsInDetails(state, { index, field, value }) {
      var data = state.details.attributeGroups[index];
      data[field] = value;
      Vue.set(state.details.attributeGroups, index, data);
    },
    addProductAttributeInAttributeGroupInDetails(state, { index, pa }) {
      var data = state.details.attributeGroups[index];
      if (!data.productAttributes) data.productAttributes = [];

      var model = {
        attributeId: pa.attributeId.id,
        attribute: { name: pa.attributeId.name }
      };
      if (pa.attributeType == 0) model.singleOptions = [];
      if (pa.attributeType == 1) model.selectiveOptions = [];
      if (pa.attributeType == 2) {
        model.maxLength = 500;
      }
      data.productAttributes.unshift(model);

      Vue.set(state.details.attributeGroups, index, data);
    },
    updateProductAttributesInAttributeGroupDetails(
      state,
      { groupIndex, productIndex, options }
    ) {
      var group = state.details.attributeGroups[groupIndex];
      var productAttribute = group.productAttributes[productIndex];
      productAttribute[
        productAttribute.singleOptions ? "singleOptions" : "selectiveOptions"
      ] = options.map(x => {
        if (typeof x == "string") return { value: x };
        return x;
      });

      Vue.set(state.details.attributeGroups, groupIndex, group);
    },
    removeGroup(state, index) {
      var g = state.details.attributeGroups[index];
      state.details.attributeGroups = state.details.attributeGroups.filter(
        x => x.id !== g.id
      );
    },
    removeProductAttribute(state, { gIndex, paIndex }) {
      var g = state.details.attributeGroups[gIndex];
      var pa = g.productAttributes[paIndex].attributeId;
      state.details.attributeGroups[
        gIndex
      ].productAttributes = state.details.attributeGroups[
        gIndex
      ].productAttributes.filter(x => x.attributeId !== pa);
    }
  }
};
